export const order_ruleset1_PD_GV  = 'bestrank.rank is not null DESC, abs(1 - v), PN, label';
